import { getTemplatesMetaTranslations } from "./modules/templatesMeta";
import { getOperationsTranslations } from "./modules/operations";
import { getMarketingTranslations } from "./modules/marketing";
import { getAutomationTranslations } from "./modules/automation";
import { getAnalyticsTranslations } from "./modules/analytics";
import { getPublicAccessTranslations } from "./modules/publicAccess";

const messages = {
  en: {
    translations: {
      publicAccess: getPublicAccessTranslations("en"),
      settingsSuite: {
        common: { updating: "UPDATING...", enabled: "✓ ENABLED", disabled: "✕ DISABLED", saving: "SAVING...", save: "SAVE", sending: "SENDING...", sendTest: "SEND TEST", generating: "Generating...", restoring: "Restoring..." },
        page: { schedulesSuccess: "Business hours updated successfully.", serviceCompletion: "Service completion", whitelabel: "White label" },
        branding: { section: "Login screen / Branding", title: "Customize your brand experience", help: "Configure the login banner, logo, links, and text without changing code or creating a new build.", smtp: "Email (SMTP)", port: "Port", secure: "Secure (SSL/TLS)", secureHelp: 'Use "true" for a secure connection and "false" for STARTTLS/standard.', appPassword: "App password", sender: "Sender (FROM)", senderExample: "Example: Your company <support@gmail.com>", testEmail: "Test email", testEmailHelp: "If left blank, the email above will be used.", whatsappLogin: "Show WhatsApp button on the login screen", bannerMode: "Banner mode", imageUrl: "Image URL", internalUpload: "Upload / internal image", whatsappNumber: "WhatsApp number on login", loginLogo: "Login screen logo", logoUrl: "Login screen logo URL", logoUpload: "Logo upload", sendLogo: "Upload logo", removeUpload: "Remove upload", logoPriority: "An uploaded file takes precedence over the logo URL.", logoPreview: "Logo preview", noLogo: "No logo configured", loginBanner: "Login screen banner", bannerUrl: "Banner image URL", bannerUpload: "Banner upload", sendBanner: "Upload banner", bannerInternalHelp: "When upload/internal image mode is selected, the system will use this file.", bannerPreview: "Banner preview", noBanner: "No banner configured", bannerTitle: "Banner title", bannerSubtitle: "Banner subtitle" },
        meta: { section: "Meta / Facebook / Instagram integration", title: "Configure the Meta connection directly in the system", help: "These settings are used on the connections screen for Facebook and Instagram login, without relying on .env or creating a new build.", appIdHelp: "Enter your Meta application App ID", appSecretHelp: "Enter your Meta application App Secret", embeddedSignupConfigId: "Embedded Signup configuration ID (optional)", embeddedSignupConfigIdHelp: "Required only when using the Connect with Coexistence button.", sdkVersion: "Meta SDK version", permission: "Require business_management permission" },
        options: { general: "General settings", currency: "Company currency", currencyHelp: "Used for sales, Kanban, reports and financial values.", currencyUpdated: "Currency updated successfully!", supportNumber: "Support number", supportHelp: "Number with country code, used by the Call Support button.", aiSection: "AI — Reply suggestions", enableSuggestions: "Enable reply suggestions", openAiKey: "OpenAI API key", aiModel: "AI model", analyzedMessages: "Number of messages analyzed", aiPrompt: "AI prompt", scheduleBot: "Scheduling and bot", companyRegistration: "Company registration", requireDocument: "Require tax ID during registration", push: "Push notifications", pushEnabled: "Push enabled", pushHelp: "Enable push notifications in this browser for new messages.", copyPrefix: "Contact copy prefix settings", efi: "Efí Pix settings (GerenciaNet)", sendCertificate: "Upload Efí .P12 certificate", noCertificate: "No certificate uploaded", certificatePassword: "Efí certificate password" },
        backup: { sqlSuccess: "SQL backup downloaded successfully!", sqlError: "Could not generate the SQL backup.", jsonSuccess: "JSON backup downloaded successfully!", jsonError: "Could not generate the JSON backup.", sqlOnly: "Only .sql files can be restored.", confirm: "WARNING: restoring will overwrite the current database. Are you sure you want to continue? We recommend creating a backup first.", restoreSuccess: "Database restored successfully! Reload the page.", restoreError: "Could not restore the database.", title: "Database backup", description: "Download a complete copy of the database in your preferred format.", sql: "SQL backup (.sql)", json: "JSON backup (.json)", tip: "SQL backup is ideal for a full restore. JSON backup is useful for analysis and data migration.", restoreTitle: "Restore database", danger: "Danger zone:", dangerHelp: "Restoring will overwrite all current database data. Make sure you have a recent backup before continuing.", upload: "Upload .sql file to restore", companyTitle: "Backup by company", companyDescription: "Export only the selected company's data, including relational links.", selectCompany: "Select company", companySQL: "Company as SQL", companyJSON: "Company as JSON", companySuccess: "Company backup downloaded successfully!", companyError: "Could not generate the company backup.", companyListError: "Could not load companies.", selectCompanyError: "Select a company." }
        ,completion: { title: "Service completion", saleValue: "Request the sale amount when completing service", saleValueHelp: "When enabled, the sale amount field appears in the completion dialog.", reasons: "Completion reasons", addReason: "Add reason", noReasons: "No reasons registered. Click Add reason to begin.", reasonName: "Reason name", description: "Description (optional)", nameRequired: "The reason name is required.", updated: "Reason updated successfully!", created: "Reason created successfully!", deleted: "Reason deleted successfully!", configUpdated: "Settings updated successfully!", configError: "Could not update the settings." }
        ,certificate: { noPermission: "You do not have permission to access this feature!", p12Only: "Only .p12 files are allowed!", chooseFile: "Choose a file!", chooseDestination: "Choose a destination!", sent: "File uploaded successfully!", title: "Efí certificate — Pix API (.p12)", chooseOption: "Choose an option:", option: "Efí .p12 certificate for the Pix API", send: "UPLOAD CERTIFICATE" }
        ,paymentGuide: { title: "Mercado Pago integration", intro: "Follow these steps to integrate your system with Mercado Pago:", account: "Create an account on Mercado Pago Developers.", application: "Create an application on Mercado Pago Developers.", production: "Open Production and Production credentials.", copyKey: "Copy the credential and paste it into the Access Token field.", notifications: "In Mercado Pago, open Notifications and Webhooks.", webhook: "In Production mode, enter the displayed URL and select Payments under Events." }
        ,aiHelp: { apiKeySaved: "Your OpenAI key will be stored in the database.", modelExample: "Example: gpt-4o-mini", recommendedRange: "Recommended: 10 to 20 messages", promptHelp: "Define how the AI should respond." }
      },
      connectionSuite: {
        common: { yes: "Yes", no: "No", cancel: "Cancel", close: "Close", save: "Save", confirm: "Confirm", loading: "Loading...", error: "Error", status: "Status", details: "Details", createdAt: "Created at", updatedAt: "Updated at", requiredPhone: "Enter the phone number.", brazilFormat: "For Brazilian numbers, use 55 + area code + number.", pairingCodeMissing: "The server did not return a pairing code.", digitsHelp: "digits — country code + area code + number", waitingCode: "Waiting for code...", enterCodeNow: "Enter the code in WhatsApp", codeExpiring: "Code expiring!", generateCode: "Generate code", activationHistory: "Official API activation history", connection: "Connection", stepType: "Connection type", stepMeta: "Connect with Meta", stepFinish: "Finish", processing: "Processing...", waitingMeta: "Waiting for Meta...", finishOnboarding: "Complete onboarding" },
        list: { transferProgress: "Transferring tickets", tickets: "tickets", transferWait: "Please wait while the tickets are transferred...", beforeDelete: "Before deleting", beforeDeleteHelp: "Have you transferred this connection's tickets to another connection? If not, we recommend transferring them before deleting it.", notYet: "Not yet", whatsappOfficial: "Official WhatsApp", diagnosticsTooltip: "Connection diagnostics", logsTooltip: "Onboarding logs", syncTemplatesTooltip: "Sync templates", copyWebhookTooltip: "Copy webhook", selectConnections: "Select the source and destination connections.", differentConnections: "The source and destination connections must be different.", metaLoginCancelled: "Meta login was not completed.", metaAppIdMissing: "Configure the Meta App ID in the system settings.", metaSettingsLoading: "Loading Meta settings. Please wait a moment.", metaStarting: "The Meta integration is still starting. Try again in 2 seconds.", metaSdkLoading: "The Meta SDK is still loading. Try again in a few seconds.", metaSdkUnavailable: "The Facebook SDK is unavailable. Reload the page." },
        modal: { connectionNameRequired: "Enter the connection name.", telegramCredentialsRequired: "Enter the API ID, API Hash, and phone number.", telegramCodeSent: "Code sent by Telegram. Check the Telegram app.", sendCodeFirst: "Send the code first.", telegramCodeRequired: "Enter the code received in Telegram.", twoFactorRequired: "The two-factor authentication password is required. Enter it and confirm again.", sessionDisconnected: "Session disconnected successfully. Wait a few seconds, then generate the QR Code again on the same connection.", saveChangesFirst: "Click Save to register the changes.", officialOnboarding: "Official API self-service onboarding", officialOnboardingHelp: "Connect the Official API through Meta Embedded Signup and, when eligible, use coexistence with the existing WhatsApp Business number.", onboardingStatus: "Onboarding status", connectionHealth: "Connection health", signedWebhook: "Webhook subscribed", displayedNumber: "Displayed number", verifiedName: "Verified name", lastError: "Last error", connectMeta: "Connect with Meta", welcomeFlow: "Welcome flow", welcomeFlowHelp: "This flow is triggered only for new contacts: people who are not in your contact list and who sent a message.", defaultResponseFlow: "Default response flow", defaultResponseFlowHelp: "The default response is sent when the message does not match a keyword. Warning: it will be triggered if the service ticket is already closed." },
        diagnostics: { title: "Official API diagnostics", help: "Validates the token, number, app subscription, and webhook, and lets you reconnect or test sending.", reconnectSuccess: "Reconnection requested successfully.", testNumberRequired: "Enter the test number.", textSuccess: "Test text message sent successfully.", templateNameRequired: "Enter the template name.", templateSuccess: "Test template message sent successfully.", tokenPresent: "Token present", tokenValid: "Token valid", wabaPresent: "WABA ID present", phoneIdPresent: "Phone Number ID present", numberAccessible: "Number accessible", appSubscribed: "App subscribed to WABA", finalStatus: "Final status", textTest: "Text test", textTestHelp: "Use this when there is an open 24-hour window with the contact.", testMessage: "Test message", templateTest: "Template test", templateTestHelp: "Use outside the 24-hour window with a template approved by Meta.", templateName: "Template name", templateLanguage: "Template language", templateParameters: "Template parameters", parametersHelp: "Separate parameters with commas, in the same order as the template.", update: "Update diagnostics", reconnect: "Reconnect" },
        embedded: { title: "Official API self-service onboarding", chooseType: "Choose the connection type", newNumber: "New number / new Official API connection", newNumberHelp: "Ideal for activating a new number directly through Meta's flow.", currentNumber: "Use my current WhatsApp Business number", currentNumberHelp: "Coexistence flow for eligible WhatsApp Business App accounts.", connectionName: "Connection name", finalTestNumber: "Final test number", selectedMode: "Selected mode", continueHelp: "When you continue, the system will open Meta onboarding to authorize and link the number and complete the connection.", capturedData: "Onboarding data captured", returnedCode: "Code returned by Meta", nextStep: "Next step", nextStepHelp: "The backend will exchange the code for a token, sync WABA data, subscribe the webhook, validate the connection, and try to send the test message.", connectionId: "Connection ID", diagnostic: "Diagnostics", capturedSuccess: "Meta response captured successfully.", incompleteData: "Embedded Signup data is incomplete.", completed: "Official API onboarding completed successfully.", createdSuccess: "Connection created successfully", createdPending: "Connection created with pending items" },
        logs: { title: "Official onboarding logs", empty: "No logs found for this connection.", error: "Error", payload: "Payload" },
        pairing: { title: "Connect with pairing code", enterNumber: "Enter the WhatsApp number with", countryCode: "country code + area code", example: "Example", whatsappNumber: "WhatsApp number", tooShort: "Number is too short. Include the country code and area code.", tooLong: "Number is too long.", connected: "Connected!", connectedHelp: "WhatsApp paired successfully. This window will close automatically.", instructions: "On WhatsApp, go to:", path: "Settings → Linked devices → Link a device", tap: "Tap", phoneLink: "Link with phone number", enterCode: "and enter the code exactly as shown (without spaces):", waiting: "Waiting for you to enter the code in WhatsApp...", syncing: "Syncing session... Almost there!", tryAgain: "Try again", success: "WhatsApp connected successfully!", failed: "Pairing failed. Try again.", alreadyConnected: "WhatsApp is already connected!", generated: "Code generated! Enter it in WhatsApp within 60 seconds." }
      },
      finalTouches: {
        common: { remove: "Remove", online: "Online", offline: "Offline" },
        ai: {
          title: "AI Sales Agent", newAgent: "New agent", newTitle: "New AI Sales Agent", editTitle: "Edit AI Sales Agent",
          pageHelp: "Configure sales agents to automatically respond to leads, qualify opportunities, apply tags, generate internal summaries, and transfer to human service.",
          modalHelp: "Configure the agent to qualify leads, apply tags, generate an internal summary, and transfer to human service when necessary.",
          onlyPending: "Pending only", allConnections: "All", transferQueue: "Transfer queue", validConfig: "Valid configuration",
          interactions: "Interactions", empty: "No configuration found.", removeTitle: "Remove configuration?",
          removeNamed: "Remove configuration {{name}}?", removeHelp: "This action does not remove previously registered sessions, only the agent configuration."
        },
        warmup: {
          title: "Chip Warm-up", subtitle: "Connections isolated for warm-up, separate from the system's standard connections.", unavailableTitle: "Chip Warm-up unavailable", unavailableHelp: "Your current plan does not include access to this feature.",
          waitingQr: "Waiting for QR", minDelayError: "The minimum delay must be greater than 1000 ms.", maxDelayError: "The maximum delay must be greater than or equal to the minimum.", saved: "Configuration saved successfully!",
          statusTitle: "Warm-up status", cluster: "Cluster", running: "running", stopped: "stopped", onlineConnections: "Online connections", active: "Warm-up active", paused: "Warm-up paused", configuration: "Configuration",
          minDelay: "Minimum delay (ms)", maxDelay: "Maximum delay (ms)", messagesPerCycle: "Messages per cycle", prompt: "Alternating phrases / prompt", promptHelp: "Enter one phrase per line. The system will randomly select and alternate them.", saveConfig: "Save configuration",
          newConnection: "New connection", group: "Group", createQr: "Create connection / generate QR", connectionsTitle: "Warm-up connections", noNumber: "No number provided", session: "Session", reconnect: "Generate QR / Reconnect", empty: "No warm-up connections registered.", scanQr: "Scan the QR Code"
        },
        financial: {
          subtitle: "Track your invoices, due dates, and payments in one place.", subscriptionStatus: "Subscription status", active: "Active", expired: "Expired", currentDueDate: "Current due date", totalRegistered: "Total registered", open: "Open", awaitingPayment: "Awaiting payment", processing: "Processing", confirming: "Confirmation in progress", paidPlural: "Paid", alreadyConfirmed: "Already confirmed",
          organizedTitle: "Organized financial area", organizedHelp: "View invoices, track due dates, and make payments more clearly.", expiredTitle: "Your subscription has expired", expiredHelp: "Complete the payment to keep the system fully operational.", processingTitle: "Payment processing", processingHelp: "We identified a recent subscription payment. After provider confirmation, the update may take an average of 5 to 10 minutes.", pendingHelp: "If you have already completed the payment, confirmation may take 5 to 10 minutes. This page will update automatically.",
          whatNow: "What happens now?", autoUpdateHelp: "Once confirmation is complete, the page will update automatically. You can remain on this page and track the status.", invoice: "Invoice", value: "Amount", waitingTime: "Waiting time", minutes: "{{count}} minute(s)", updateNow: "Update now", viewProcessing: "View payment in progress", notPaidYet: "I haven't paid yet", success: "Payment confirmed successfully. The subscription has been updated.", paymentConfirmed: "Payment confirmed", dueToday: "Due today", daysLeft: "{{count}} day(s) left", daysOverdue: "{{count}} day(s) overdue", subscriptionInvoice: "Subscription invoice", pay: "PAY", paid: "PAID", empty: "No invoices found", emptyHelp: "Financial entries will appear here as soon as they are available.", statuses: { open: "Open", processing: "Processing", overdue: "Overdue", paid: "Paid" }
        },
        checkout: {
          subscriptionPayment: "Subscription payment", subscriptionPaymentHelp: "Choose a payment method and complete your renewal securely.", providerHelp: "After completing payment, confirmation may take a few minutes to appear in the system. The subscription will update automatically once the provider confirms it.", data: "Details", customize: "Customize", review: "Review", finishRenewal: "Complete your renewal", finishRenewalHelp: "Generate your charge securely and track payment confirmation in the system.", confirmedHelp: "We received payment confirmation and the subscription has already been updated.", processingHelp: "After completing payment, confirmation may take an average of 5 to 10 minutes. The update will happen automatically.", chargeCreated: "Charge created successfully! After payment, confirmation may take 5 to 10 minutes.", back: "BACK", next: "NEXT", generatePayment: "GENERATE PAYMENT", month: "month", select: "SELECT", subscriptionSummary: "Subscription summary", planDetails: "Plan details", users: "Users", connections: "Connections", queues: "Queues", billing: "Billing", monthly: "Monthly", paymentInformation: "Payment information", email: "Email", name: "Name", taxId: "Tax ID", total: "Total", stepNotFound: "Step not found", invoiceNumber: "Invoice #{{id}}", licenseRenewed: "Your license has been renewed until {{date}}!", copied: "Copied", copyPix: "Copy PIX QR code", pixHelp: "To finish, pay by scanning or pasting the PIX code above, or choose to pay by credit card below.", payCreditCard: "Pay by Credit Card", payMercadoPago: "Pay with MercadoPago", payAsaas: "Pay with Asaas"
        }
      },
      adminOps: {
  "navigation": {
    "serverReport": "Server Report",
    "aiSalesAgent": "AI Sales Agent"
  },
  "server": {
    "restricted": "Restricted access",
    "restrictedHelp": "The Server Report is available only to the Super Admin.",
    "title": "Server Report",
    "subtitle": "Premium system health panel: infrastructure, services, commercial modules, Official API, Wavoip, Landing Pages, Flowbuilder, Follow-up, Chip Warm-up, and integrations.",
    "loading": "Loading system information...",
    "refresh": "Refresh",
    "online": "Online",
    "available": "Available",
    "warning": "Warning",
    "critical": "Critical",
    "offline": "Offline",
    "unknown": "Check",
    "noDetails": "No additional details",
    "memory": "RAM Memory",
    "disk": "Disk",
    "cores": "{{count}} cores",
    "usedOf": "{{used}} GB used of {{total}} GB",
    "environment": "Environment",
    "product": "Product",
    "module": "Module",
    "server": "Server",
    "system": "System",
    "serverUptime": "Server uptime",
    "backendUptime": "Backend uptime",
    "updatedAt": "Updated at",
    "pm2Services": "PM2 Services",
    "infrastructureTitle": "Infrastructure",
        "infrastructure": {
          "database": "Main system database.",
          "redis": "Cache, queues, socket adapter, and real-time features.",
          "nginx": "Reverse proxy and HTTPS publishing for services.",
          "pm2": "Node.js process manager."
        },
    "systemModules": "System modules",
    "modulesHelp": "Strategic features available in the flagship system.",
    "overallHealthy": "All key indicators are operating normally.",
    "memoryDetail": "memory",
    "service": {
      "backend": {
        "name": "System backend",
        "description": "Main API, authentication, tickets, messages, and integrations."
      },
      "frontend": {
        "name": "System frontend",
        "description": "Web interface for administration and customer service."
      },
      "official": {
        "name": "Official API",
        "description": "Dedicated service for WhatsApp Cloud API / Meta."
      },
      "transcription": {
        "name": "Transcription",
        "description": "Auxiliary service for audio transcription and processing."
      }
    },
    "feature": {
      "followup": "Schedules, reminders, and commercial continuity.",
      "official": "Official WhatsApp, templates, media, and service window.",
      "warmup": "Module for warming up and preparing connections.",
      "email": "Settings, events, and infrastructure for sending emails.",
      "wavoip": "Calls, history, and integrated telephony.",
      "landing": "Lead capture through forms, WordPress, and Elementor.",
      "flowbuilder": "Flows, automations, and visual campaigns.",
      "asaas": "Billing lookup and duplicate payment slips.",
      "radar": "Intelligent conversation analysis and sales suggestions.",
      "campaigns": "Broadcasts, lists, reports, and campaign settings.",
      "codeModule": "Module found in code",
      "configured": "Configured in the environment"
    },
    "featureName": {
      "followup": "Follow-up",
      "official": "Official API",
      "warmup": "Chip Warm-up",
      "email": "Email Marketing",
      "wavoip": "Wavoip",
      "landing": "Landing Pages",
      "flowbuilder": "Flowbuilder",
      "asaas": "Asaas / Payment Slips",
      "radar": "Opportunity Radar",
      "campaigns": "Campaigns"
    }
  },
  "ai": {
    "title": "AI Sales Agent",
    "newAgent": "New agent",
    "pageHelp": "Configure sales agents to automatically respond to leads, qualify opportunities, apply tags, generate internal summaries, and transfer to human support.",
    "newTitle": "New AI Sales Agent",
    "editTitle": "Edit AI Sales Agent",
    "modalHelp": "Configure the agent to qualify leads, apply tags, generate internal summaries, and transfer to human support when needed.",
    "name": "Name",
    "status": "Status",
    "connection": "Connection",
    "queue": "Queue",
    "agent": "Agent",
    "interactions": "Interactions",
    "actions": "Actions",
    "active": "Active",
    "inactive": "Inactive",
    "onlyWaiting": "Waiting only",
    "all": "All",
    "transferQueue": "Transfer queue",
    "noQueue": "No queue",
    "notDefined": "Not defined",
    "model": "AI Model",
    "temperature": "Temperature",
    "maxInteractions": "Maximum interactions",
    "welcomeMessage": "Initial message",
    "salesPrompt": "Sales prompt",
    "promptHelp": "Leave blank to use the system default prompt.",
    "questions": "Qualification questions, one per line",
    "tags": "Automatic tags, one per line",
    "transferHuman": "Transfer to human",
    "createOpportunity": "Create opportunity",
    "validConfig": "Valid configuration",
    "cancel": "Cancel",
    "save": "Save",
    "edit": "Edit",
    "remove": "Remove",
    "empty": "No configurations found.",
    "removeTitle": "Remove configuration?",
    "removeNamed": "Remove configuration {{name}}?",
    "removeHelp": "This action does not remove previously registered sessions, only the agent configuration.",
    "updated": "Configuration updated successfully.",
    "created": "Configuration created successfully.",
    "enabled": "AI Sales Agent enabled.",
    "disabled": "AI Sales Agent disabled.",
    "removed": "Configuration removed successfully."
  },
  "connections": {
    "transferTickets": "Transfer Tickets",
    "transferTitle": "Ticket Transfer",
    "transferHelp": "Select the source and destination connections. All active services will be moved.",
    "source": "Source",
    "destination": "Destination",
    "confirmTransfer": "Yes, transfer",
    "metaSetup": "Configure Meta in the system",
    "officialMeta": "Coexistence",
    "connectingFacebook": "Connecting Facebook...",
    "loadingFacebook": "Loading Facebook...",
    "connectingInstagram": "Connecting Instagram...",
    "loadingInstagram": "Loading Instagram...",
    "receiveComments": "Receive Comments",
    "sent": "SENT",
    "received": "RECEIVED",
    "dailyLimit": "Daily limit",
    "messagesDay": "msg/day",
    "status": {
      "CONNECTED": "CONNECTED",
      "DISCONNECTED": "DISCONNECTED",
      "OPENING": "CONNECTING",
      "PENDING": "PENDING",
      "TIMEOUT": "TIMEOUT",
      "PAIRING": "PAIRING"
    },
    "pairingCode": "Connected via Pairing Code",
    "qrCode": "Connected via QR Code"
  },
  "modal": {
    "chatbot": "Chatbot",
    "defaultFlow": "Default Flow",
    "telegramConfig": "Telegram Settings",
    "personalProfile": "Personal profile",
    "personalHelp": "uses API ID, API Hash, and phone number. The account receives a code in the Telegram app. It does not use BotFather, a token, or a webhook. It works as a connected session, similar to WhatsApp Web. Visit:",
    "botHelp": "create a bot in @BotFather, copy the token, and paste it below. The system registers the webhook automatically.",
    "telegramType": "Telegram connection type",
    "generatedAtTelegram": "Generated at my.telegram.org",
    "generatedWithApi": "Generated together with the API ID",
    "phoneCountry": "Phone with country code",
    "receivedCode": "Received code",
    "twoFactor": "2FA password, if any",
    "sendCode": "Send code",
    "confirm": "Confirm",
    "botToken": "Telegram Bot Token",
    "botTokenHelp": "Paste the token generated in @BotFather here. The webhook will be configured automatically.",
    "importHistory": "Import history on connection",
    "importDays": "Days to import",
    "maxDays": "Maximum allowed: 30 days",
    "sessionTitle": "WhatsApp Session",
    "sessionHelp": "Use this option when the connection is stuck on \"Connecting\" or \"Opening\". It disconnects only the current session for this connection so a new QR Code can be generated without creating another connection.",
    "sessionHistory": "History remains linked to the current connection as long as the backend only clears the session/auth and does not delete the connection.",
    "disconnectSession": "Disconnect session"
  }
},
      templatesMeta: getTemplatesMetaTranslations("en"),
      operations: getOperationsTranslations("en"),
      taskCleanup: {
        cleanResolved: "Clean resolved tasks",
        tasks: "Tasks",
        allResolved: "All resolved",
        allCompleted: "All completed",
        allRejected: "All rejected",
        delete: "Delete",
        deleting: "Deleting...",
        confirmAll: "all completed and rejected tasks",
        confirmCompleted: "all completed tasks",
        confirmRejected: "all rejected tasks",
        confirmQuestion: "Do you really want to delete {{items}}?",
        permanentWarning: "This action is permanent and cannot be undone.",
        noneFound: "No tasks were found in this category.",
        oneDeleted: "1 task deleted successfully.",
        manyDeleted: "{{count}} tasks deleted successfully.",
        deleteError: "Unable to delete the resolved tasks.",
        team: "Team",
        pending: "Pending",
        today: "Today",
        overdue: "Overdue",
        withoutDeadline: "No due date",
      },
      marketing: getMarketingTranslations("en"),
      automation: getAutomationTranslations("en"),
      analytics: getAnalyticsTranslations("en"),
      i18nFix: {
        flowExportZip: "Export (.zip)",
        flowOpen: "Open flow",
        flowEdit: "Edit flow",
        flowDelete: "Delete flow",
        flowDeleted: "Flow deleted successfully",
        flowDuplicated: "Flow duplicated successfully",
        flowDeleteNamed: 'Delete flow "{{name}}"?',
        kanbanStage: "Kanban stage", selectKanbanStage: "Select a Kanban stage",
        contactImportExport: "Export / Import contacts", kanban: "Kanban",
        queueDeleted: "Queue deleted successfully!", selectRotationType: "Select the rotation type",
        deleteNestedOptions: "Are you sure? All nested options will also be deleted",
        facebookConnectionSuccess: "Facebook connected successfully!", contactListSaved: "Contact list saved successfully!",
        createdAt: "Created at", updatedAt: "Updated at", to: "To", getUsersError: "Error loading users",
        loading: "Loading...", messageSaved: "Message saved successfully!", addMessage: "Add message", editMessage: "Edit message",
        integrationDeleted: "Integration deleted successfully!", category: "Category", language: "Language", metaId: "Meta ID", status: "Status",
        quickMessageDeleted: "Quick reply deleted successfully!", scheduleDeleteTitle: "Delete schedule",
        scheduleDeleteMessage: "Are you sure you want to delete this schedule?", scheduleDeleted: "Schedule deleted successfully!",
        invalidPhoneFormat: "Invalid phone number format", integrationTriggered: "Integration triggered successfully!", keyword: "Keyword",
        connectionTitle: "Connection", webhookSaved: "Webhook saved successfully!", addWebhook: "Add webhook",
        editWebhook: "Edit webhook", webhookUpdated: "Webhook updated successfully!",
      },
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User successfully created! Please log in!",
          disabled:
            "User registration is currently disabled. Please try again later.",
          fail: "Error creating user. Please check the provided data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          company: "Organization Name",
          phone: "WhatsApp (Area Code + Number)",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      ticketInfo: {
        copyPhone: "Copy Phone",
        quickMessages: "Quick Replies",
        phonecopied: "Phone copied to clipboard!",
        noPhone: "No phone available to copy",
        copyError: "Error copying phone",
      },
      login: {
        title: "Login",
        welcome: "Welcome back",
        loginInstruction: "Enter your credentials to access your account",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company successfully created!",
        },
      },

      auth: {
        toasts: {
          success: "Login successful!",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filters",
        filter: "FILTER ",
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
        },
        charts: {
          perDay: {
            title: "Attendances today: ",
          },
        },
        cards: {
          inAttendance: "In Attendance",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Finalized",
          newContacts: "New Contacts",
          totalReceivedMessages: "Received Messages",
          totalSentMessages: "Sent Messages",
          averageServiceTime: "Average Service Time",
          averageWaitingTime: "Average Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Attendances",
          statusNow: "Current Status",
          totalCallsUser: "Total Attendances per User",
          totalAttendances: "Total Attendances",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Attendances",
          callsWaitRating: "Attendances Waiting for Rating",
          callsWithoutRating: "Attendances Without Rating",
          ratedCalls: "Rated Attendances",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
        },
      },
      reports: {
        title: "Research Reports",
        operator: "Operator",
        period: "Period",
        until: "Until",
        date: "Date",
        reportTitle: "Reports",
        calls: "Attendances",
        search: "Surveys",
        durationCalls: "Attendance Duration",
        grupoSessions: "Group Attendances",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generating compressed report, please wait.",
          errorToast: "Error generating report",
          back: "Back",
          groupServiceReport: "Group Attendance Report",
          loading: "Loading...",
          contact: "Contact",
          dateOpen: "Opening Date",
          dateLastUpdated: "Last Update Date",
          agent: "Agent",
          agentClosed: "Agent who closed",
          waitingAssistance: "Waiting for Service",
          process: "In Service",
        },
        researchReports: {
          response: "Response",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantity",
          percentage: "Percentage",
          title: "Research Reports",
          activeSearch: "Active Survey",
          inactiveSearch: "Inactive Survey",
        },
        ticketDurationDetail: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Duration Report",
          startService: "Start of Attendance",
          lastUpdated: "Last Updated",
          lastAgent: "Last Agent",
          durationFinished: "Duration After Closing",
        },
        ticketDuration: {
          title: "Attendance Duration Report",
          contact: "Contact",
          open: "Open",
          pending: "Pending",
          finished: "Finished",
          durationFinished: "Duration of Finished Attendances",
          durationAfterFinished: "Duration After Closing",
          actions: "Actions",
        },
        ticketReports: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Report",
        },
        exportExcel: {
          title: "Attendance Reports",
          startDate: "Start date",
          endDate: "End date",
          notInformed: "Not informed",
          columns: {
            id: "ID",
            connection: "Connection",
            contact: "Contact",
            user: "User",
            queue: "Queue",
            status: "Status",
            lastMessage: "Last Message",
            openDate: "Open Date",
            openTime: "Open Time",
            closeDate: "Close Date",
            closeTime: "Close Time",
            supportTime: "Support Time",
            nps: "NPS",
          },
        },
        pdf: {
          title: "List of Completed Attendances",
          exportTitle: "List of Completed Group Attendances",
        },
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        task: "Tasks",
      },
      contactImportWpModal: {
        title: "Export Contacts to Excel",
        buttons: {
          downloadModel: "Download Excel template for import",
          closed: "Close",
          import: "Select Excel file to import Contacts",
        },
      },
      connections: {
        title: "Connections",
        waitConnection: "Please wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Connect your service channels to receive messages and start conversations with your customers.",
        client: "Client",
        connectedConnections: "Connected connections",
        disconnectedConnections: "Disconnected connections",
        totalConnections: "Total connections",
        total: "Total",
        connections: " Connections:",
        toasts: {
          deleted: "Connection successfully deleted!",
          closedimported:
            "Closing imported tickets, please wait a few moments.",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage:
            "If you confirm, all imported tickets will be closed.",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          closedImported: "Close all imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message Date",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your phone is connected to the internet and try again, or request a new QR Code.",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content:
              "Click the 'QR CODE' button and scan the QR Code with your phone to start the session.",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection with the phone was lost",
            content:
              "Make sure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR Code.",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "WhatsApp Number",
          color: "Color",
          receiveComments: "Receive Comments",
        },
        receiveComments: {
          enabled: "Comment receiving enabled",
          disabled: "Comment receiving disabled",
          tooltip: {
            enabled: "Comments are being received. Click to disable.",
            disabled: "Comments are not being received. Click to enable.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Attendance",
        },
        form: {
          message: "This contact is already being attended to:",
          user: "Agent",
          queue: "Queue",
          messageWait:
            "This contact is already waiting for service. Check the Waiting tab!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue assigned.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to the queue.",
          closed: "closed the ticket.",
          reopen: "reopened the ticket.",
          redirect: "- redirected",
          clientClosed: "Client closed the ticket.",
        },
      },
      whatsappModal: {
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
        },
        form: {
          importOldMessagesEnable: "Import messages from device",
          importOldMessages: "Start date of import",
          importRecentMessages: "End date of import",
          importOldMessagesGroups: "Import group messages",
          closedTicketsPostImported: "Close tickets after import",
          name: "Name",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc:
            "Select a queue for contacts without an assigned queue",
          default: "Default",
          group: "Allow groups",
          timeSendQueue: "Time in minutes to redirect to queue",
          importAlert:
            "WARNING: Saving will terminate your connection. You will need to scan the QR Code again to import messages.",
          groupAsTicket: "Treat groups as ticket",
          timeCreateNewTicket: "Create a new ticket after X minutes",
          maxUseBotQueues: "Send bot X times",
          maxUseInactiveTime: "Send inactivity flow X times",
          timeUseBotQueues: "Send bot in X minutes",
          timeToReturnQueue: "Time to return to queue in minutes",
          timeAwaitActiveFlow: "Time to wait for active flow",
          expiresTicket: "Close open chats after X minutes",
          expiresTicketNPS: "Close chats awaiting evaluation after X minutes",
          maxUseBotQueuesNPS: "Max times evaluation is sent",
          closeLastMessageOptions1: "From agent/client",
          closeLastMessageOptions2: "From agent only",
          outOfHoursMessage: "Out-of-hours message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Obfuscate messages deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Evaluation message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity warning message",
          timeInactiveMessage: "Time in minutes to send inactivity warning",
          flowInactiveTime: "Time in minutes to send inactivity flow",
          whenExpiresTicket: "Close chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          prompt: "Prompt",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue for message import",
          isOficial: "Official",
          phone_number_id: "Phone Number ID",
          waba_id: "WABA ID",
          send_token: "Sending token",
          business_id: "Business ID",
          phone_number: "Phone number",
          triggerIntegrationOnClose: "Trigger Integration on Ticket Close",
          enableIntegration: "Habilited Integration",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          minutes: "minutes",
        },
        success: "Connection saved successfully.",
        errorSendQueue:
          "You set a redirection time but no queue was selected. Both fields are required.",
        errorExpiresNPS: "A timeout must be set for NPS evaluation.",
        errorRatingMessage: "An evaluation message must be provided for NPS.",
      },
      qrCode: {
        message: "Scan the QR Code to start the session",
      },
      contacts: {
        emptyTitle: "No contacts found",
        emptyDescription: "Adjust the filters or add a new contact to get started.",
        title: "Contacts",
        toasts: {
          deleted: "Contact successfully deleted!",
        },
        searchPlaceholder: "Search...",
        conversationFlows: " Conversation Flows",
        addFlow: "Add Flow",
        editFlow: "Edit Flow ",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import Contacts",
          exportContact: "Export Contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related attendances will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
        },
        loading: "Loading...",
        loadMore: "Load More",
        table: {
          name: "Name",
          whatsapp: "Connection",
          email: "Email",
          actions: "Actions",
          lastMessage: "Last Message",
          wallet: "Wallet",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
          importexport: "IMPORT / EXPORT ",
        },
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward Message",
        buttons: {
          ok: "Forward",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in Response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum Messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add Prompt",
          edit: "Edit Prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Sector/Queue",
          max_tokens: "Max Tokens in Response",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Add Contact",
          edit: "Edit Contact",
        },
        form: {
          mainInfo: "Contact Data",
          extraInfo: "Additional Information",
          name: "Name",
          number: "WhatsApp Number",
          email: "Email",
          extraName: "Field Name",
          extraValue: "Value",
          chatBotContact: "Disable Chatbot",
          termsLGDP: "LGPD Terms accepted on:",
          whatsapp: "Origin Connection:",
          assignWallet: "Customer Wallet",
        },
        buttons: {
          addExtraInfo: "Add Information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        walletLinked: "Contact linked to your wallet successfully!",
        walletError: "User has no associated queues",
        saveFirst: "Contact must be saved first",
      },
      wallets: {
        title: "Contact Wallets",
        wallet: "Wallet",
        searchPlaceholder: "Search contacts...",
        filterByUser: "Filter by User",
        allUsers: "All users",
        contact: "Contact",
        user: "User",
        queue: "Queue",
        phone: "Phone",
        email: "Email",
        actions: "Actions",
        editWallet: "Edit Wallet",
        selectUser: "Select User",
        selectQueue: "Select Queue",
        selectUserAndQueue: "Select a user and queue",
        cancel: "Cancel",
        save: "Save",
        confirmDeleteTitle: "Confirm Deletion",
        confirmDeleteMessage:
          "Are you sure you want to remove this contact from the wallet?",
        notFound: "Wallet not found.",
        deleteSuccess: "Contact removed from wallet successfully!",
        updateSuccess: "Wallet updated successfully!",
      },
      queueModal: {
        title: {
          queueData: "Queue Data",
          text: "Business Hours",
          add: "Add Queue",
          edit: "Edit Queue",
          confirmationDelete:
            "Are you sure? All integration options will be deleted.",
        },
        form: {
          name: "Name",
          color: "Color",
          orderQueue: "Queue Order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          typeRandomMode: "Rotation Type",
          greetingMessage: "Greeting Message",
          complationMessage: "Completion Message",
          outOfHoursMessage: "Out-of-Hours Message",
          token: "Token",
          integrationId: "Integration",
          fileListId: "File List",
          closeTicket: "Close Ticket",
          queueType: "Menu Type",
          message: "Return Message",
          queue: "Transfer Queue",
          integration: "Integration",
          file: "File List",
          randomizeImmediate: "Randomize Automatically (Immediate)",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip:
            "If there is only one option, it will be automatically chosen, and the bot will respond with the message and proceed",
          selectOption: "Select an Option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          toolTipMessageTitle:
            "Message is required to proceed to the next level",
          toolTipMessageContent:
            "Message is required to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
          addOptions: "Add Options",
        },
        serviceHours: {
          dayWeek: "Day of the Week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add Project",
          edit: "Edit Project",
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JSON Content",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Expiration time in minutes",
          typebotKeywordFinish: "Keyword to finish the ticket",
          typebotKeywordRestart: "Keyword to restart the flow",
          typebotRestartMessage: "Message when restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Delay (ms) between messages",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
        },
      },
      userModal: {
        warning: "To import messages, you must scan the QR Code again!",
        title: {
          add: "Add User",
          edit: "Edit User",
          updateImage: "Update Image",
          removeImage: "Delete Image",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell Message",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          whatsapp: "Default Connection",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View Tickets Without Queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default Menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View Conversations from Other Queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View Other Users' Conversations",
          userClosePendingTicket: "Allow Closing Pending Tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Real-Time Panel",
          allowConnections: "Allow Actions on Connections",
          showContacts: "View Contacts",
          showCampaign: "View Campaigns",
          allowSeeMessagesInPendingTickets: "Allow viewing pending tickets",
          showReturnQueueButton: "Show return to queue button",
          showTransferTicketButton: "Show transfer ticket button",
          showFlow: "View Automations",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
        },
        success: "User saved successfully.",
      },
      companyModal: {
        title: {
          add: "Add Company",
          edit: "Edit Company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
          message: "Message",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          assinar: "Send Signature",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add Schedule",
        },
        success: "Schedule saved successfully.",
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
          backToKanban: "BACK TO KANBAN",
        },
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in minutes to redirect to lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Lane Greeting Message",
          mediaFiles: "Media",
          rollbackLaneId: "Return to Lane after resuming attendance",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
      },
      fileModal: {
        title: {
          add: "Add File List",
          edit: "Edit File List",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add File",
        },
        form: {
          name: "File List Name",
          message: "List Details",
          fileOptions: "File List",
          extraName: "Message to send with file",
          extraValue: "Option Value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ DRAG AND DROP FILES BELOW ⬇️",
          titleFileList: "File List",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        messageHidden: "Hidden message",
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolverd: "Resolved",
        },
        toasts: {
          deleted: "The attendance you were handling has been deleted.",
        },
        notification: {
          message: "Message from",
          messageHidden: "Hidden message",
        },
        tabs: {
          open: { title: "Open" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search attendance and messages",
          filterConections: "Filter by Connection",
          filterConectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          scredule: "Schedule",
          deleteTicket: "Delete Ticket",
        },
        closedTicket: {
          closedMessage: "Close Ticket With Farewell Message",
          closedNotMessage: "Close Ticket Without Farewell Message",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to Queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No users found with that name",
        msgTransfer: "Notes - internal message, will not be sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsList: {
        called: "Call",
        today: "Today",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "In Attendance",
        groupingHeader: "Groups",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage:
          "No attendances found with this status or search term",
        noQueue: "No Queue",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "Start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Kanban Options",
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select Sector",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      SendContactModal: {
        title: "Send Contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          chatsTempoReal: "Real-Time Panel",
          tickets: "Attendances",
          quickMessages: "Quick Replies",
          contacts: "Contacts",
          wallets: "Wallets",
          queues: "Queues & Chatbot",
          tags: "Tags",
          administration: "Administration",
          companies: "Companies",
          users: "Users",
          birthdaySettings: "Birthday Settings",
          settings: "Settings",
          files: "File Lists",
          helps: "Help Center",
          messagesAPI: "API",
          schedules: "Schedules",
          campaigns: "Campaigns",
          annoucements: "Announcements",
          chats: "Internal Chat",
          financeiro: "Financial",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "Kanban",
          prompts: "Talk.AI",
          allConnections: "Manage Connections",
          reports: "Reports",
          management: "Management",
          callHistorical: "Call History",
          automations: "Automations",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token: "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          notRegister: "No records found",
          refresh: "Refresh",
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
        ar: "Arabic",
      },
      messagesAPI: {
        title: "API",
        toSend: "TO SEND",
        extended: {
          documentationTitle: "Message Sending Documentation", methodsTitle: "Sending Methods", new: "NEW",
          mediaMessages: "Media Messages", checkNumber: "Check Number", noTicket: "Send Without Ticket", imageUrl: "Image by URL", bulk: "Bulk Sending", listConnections: "List Connections", interactiveButtons: "Message with Buttons", mixedButtons: "Mixed Buttons (quick_reply + URL)",
          tokenInstruction: "Before sending messages, register the token linked to the sending connection. Open Connections, edit the connection, and enter the token.", numberInstruction: "The number must contain only Country Code + Area Code + Number, without formatting or special characters (e.g. 5511999998888).", headerInstruction: "All endpoints require the header:",
          testSend: "Send test", textTitle: "Text Messages", textDescription: "Sends a text message and registers a ticket.", mediaDescription: "Sends files (image, audio, video, or document).", checkTitle: "Check WhatsApp Number", checkDescription: "Checks whether a number has an active WhatsApp account before sending.", noTicketTitle: "Send Without Ticket (Quick Send)", noTicketDescription: "Sends a message directly without creating or registering a ticket. Ideal for quick notifications.", imageTitle: "Send Image by URL", imageDescription: "Sends an image from a public URL without uploading a file.", bulkTitle: "Bulk Sending", bulkDescription: "Sends messages to multiple numbers in one request. Limit: 100 messages per batch.", connectionsTitle: "List Available Connections", connectionsDescription: "Returns the company's active WhatsApp connections and their IDs.", buttonsTitle: "Interactive Button Message", buttonsDescription: "Sends an interactive message with up to 3 buttons. Lists, URLs, and PIX are also supported.", mixedTitle: "Mixed Buttons (quick_reply + URL + copy + call)", mixedDescription: "Sends a message with different button types. Limit of 5 buttons.",
          bodyJson: "JSON Body:", response: "Response:", registeredToken: "Registered token *", number: "Number *", message: "Message *", userId: "User/agent ID", queueId: "Queue ID", caption: "Caption (optional)", imageAddress: "Image URL *", messagesJson: "Messages JSON *", buttonsJson: "Buttons JSON *", mixedButtonsJson: "Mixed buttons JSON *", footer: "Footer", send: "Send", verify: "Check", sendBatch: "Send batch", sendButtons: "Send buttons", sendMixed: "Send mixed", list: "List connections", invalidJson: "Invalid JSON.", success: "Operation completed successfully.",
          accessDenied: "This company does not have permission to access this page.", headersJson: "Headers: Authorization Bearer (token) and Content-Type (application/json)", headersForm: "Headers: Authorization Bearer and Content-Type (multipart/form-data)", formData: "FormData:", optionalCaption: "Caption (optional)", userIdHelp: "User ID or empty", queueIdHelp: "Queue ID or empty", file: "file", delayHelp: "delay: interval in ms between sends (default: 2000)", bodyButtons: "JSON Body (Buttons):", bodyList: "JSON Body (List):", queueClick: "queueId: routes the ticket to the queue when clicked", userClick: "userId: assigns the ticket to a specific agent", maxButtons: "Max. 3 buttons (5 for mixed)", quickReplyHelp: "quick_reply: quick reply button (with id)", urlHelp: "cta_url: opens an external link", copyHelp: "cta_copy: copies text (e.g. PIX)", callHelp: "cta_call: starts a call", maxMixed: "Max. 5 buttons"
        },
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File Name",
          media: "File",
          token: "Registered Token",
        },
        API: {
          title: "Message Sending Documentation",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMidia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1:
              "Before sending messages, it is necessary to register the token linked to the connection that will send the messages. <br />To register, access the 'Connections' menu, click the edit button on the connection, and insert the token in the appropriate field.",
            comments2:
              "The sending number must not have a mask or special characters and must be composed of:",
            codeCountry: "Country Code",
            code: "Area Code (DDD)",
            number: "Phone Number",
          },
          text: {
            title: "1. Text Messages",
            instructions:
              "Below is the list of required information to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions:
              "Below is the list of required information to send media messages:",
          },
        },
      },
      birthday: {
        defaultUserMessage: "🎉 Happy birthday, {nome}! Today is your special day! We wish you much success and happiness!", defaultContactMessage: "🎉 Happy birthday, {nome}! We wish you much success, health, and happiness! ✨",
        title: "Birthday Settings", loading: "Loading settings...", users: "User Birthdays", contacts: "Contact Birthdays", general: "General Settings", selectConnection: "Select a connection", saving: "Saving...",
        enableUsers: "Enable user birthday notifications", enableUsersHelp: "Shows the congratulations dialog and creates an automatic announcement.", createUserNotice: "Create automatic user birthday announcement", createUserNoticeHelp: "Creates an announcement visible to all company users.", userMessage: "Birthday message for users", userMessageHelp: "Use {nome} to include the user's name.",
        enableContacts: "Automatically send messages to birthday contacts", enableContactsHelp: "Automatically sends a congratulations message through WhatsApp.", contactMessage: "Birthday message for contacts", contactMessageHelp: "Use {nome} for the name and {idade} for the age.", preview: "Preview:", test: "Test message", sendTime: "Message sending time", sendTimeHelp: "Time when automatic messages will be sent.", connection: "WhatsApp sending connection", connectionHelp: "Connection used to send birthday messages.", internalNotice: "Create internal user birthday announcement", internalNoticeHelp: "Creates an internal announcement when a user has a birthday.", variables: "Variables available in messages:", personName: "Person's name", personAge: "Person's age (contacts only)", save: "Save settings",
        loadError: "Could not load birthday settings.", saveSuccess: "Birthday settings saved successfully! 🎉", saveError: "Could not save settings.", promptContact: "Enter a contact ID for the test:", testSuccess: "Test message sent! 📱", testError: "Could not send the test message.", congratulations: "Happy Birthday!", specialDay: "Today is a special day!", loadingPeople: "Loading birthdays...", systemUser: "System user", alreadySent: "Message already sent", sendCongratulations: "Send congratulations", sentTo: "Congratulations sent to {{name}}! 🎉", alreadySentToast: "The birthday message has already been sent to this contact today.", sendError: "Could not send the birthday message."
      },
      notifications: {
        noTickets: "No notifications.",
        messageHidden: "Hidden message",
        newMessage: "New message from",
      },
      triggerFlowModal: {
        title: "Trigger Flow",
        description:
          "Select a flow to run on this ticket. The ticket will be changed to 'chatbot' status during execution.",
        selectFlow: "Choose a flow",
        selectedFlow: "Selected flow",
        flowId: "Flow ID",
        noFlows: "No active flows found",
        cancel: "Cancel",
        trigger: "Trigger Flow",
        triggering: "Triggering...",
        success: "Flow triggered successfully!",
        error: "Error triggering flow",
      },
      quickMessages: {
        title: "Quick Replies",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        selectMessage: "Select Quick Reply",
        hasMedia: "With media",
        global: "Global",
        noResultsFound: "No quick replies matched your search",
        noQuickMessages: "No quick replies available",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action is irreversible! Do you want to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          general: "General",
          geral: "Allow Editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow Viewing",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File Name",
          status: "Status",
        },
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage:
            "Do you want to import the contacts from this spreadsheet?",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Board",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campaigns",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Listing",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Interval",
          intervalGapAfter: "Longer interval after",
          undefined: "Undefined",
          messages: "messages",
          laggerTriggerRange: "Larger Sending Interval",
          addVar: "Add Variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Schedule",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open Ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          cancel: "Campaign canceled.",
          restart: "Campaign restarted.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignReport: {
        title: "Campaign Report",
        fetchError: "Error fetching report data",
        backButton: "Back",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        cancelled: "Canceled",
        finished: "Completed",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Schedule",
        conclusion: "Conclusion",
      },
      announcements: {
        title: "Announcements",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting Message",
          orderQueue: "Queue Order (Bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add Queue",
        },
        toasts: {
          success: "Queue saved successfully.",
          deleted: "Queue deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! Attendances from this queue will still exist but will no longer be assigned to a queue.",
        },
      },
      queue: {
        queueData: "Queue Data",
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-Only Queues",
        withoutQueue: "No Queue",
      },
      reports: {
        title: "Attendance Reports",
        startDate: "Start date ",
        endDate: "End date",

        table: {
          id: "Ticket",
          user: "User",
          dateOpen: "Opening Date",
          dateClose: "Closing Date",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Connection",
          queue: "Queue",
          actions: "Actions",
          lastMessage: "Last Message",
          contact: "Customer",
          supportTime: "Attendance Time",
        },
        buttons: {
          filter: "Apply Filter",
          onlyRated: "Only Rated",
        },
        searchPlaceholder: "Search...",
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone and will be removed from linked queues and connections.",
        },
      },
      users: {
        title: "Users",
        table: {
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add User",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Open tickets for this user will be moved to the queue.",
        },
      },
      compaies: {
        title: "Companies",
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Expiration Date",
          lastLogin: "Last Login",
          folderSize: "Folder size ",
          totalFiles: " Total Files",
          lastUpdate: "Last update",
          actions: "Actions",
          generateInvoice: "Generate Invoice",
          money: "$",
          currency: "Currency",
          brl: "BRL — Brazilian real",
          cop: "COP — Colombian peso",
          usd: "USD — US dollar",
          yes: "Yes",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
        },
        buttons: {
          add: "Add Company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets for users in this company will be moved to the queue.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          campaigns: "Campaigns",
          schedules: "Schedules",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
          currency: "Currency",
          brl: "BRL — Brazilian real",
          cop: "COP — Colombian peso",
          usd: "USD — US dollar",
          public: "Public",
          trial: "Trial",
          trialDays: "Trial Days",
        },
      },
      helps: {
        title: "Help Center",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Clear",
          delete: "Delete",
          save: "Save",
        },
      },
      schedules: {
        title: "Schedules",
        date: "Date",
        time: "Time",
        event: "Event",
        allDay: "All Day",
        week: "Week",
        work_week: "Work Week",
        day: "Day",
        month: "Month",
        previous: "Previous",
        next: "Next",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        today: "Today",
        agenda: "Agenda",
        noEventsInRange: "No events in this range.",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADD COLUMNS",
        search: "SEARCH",
        seeTicket: "SEE TICKET",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Kanban",
          color: "Color",
          tickets: "Tag Records",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Open",
        backToKanban: "BACK TO KANBAN",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "File list deleted successfully!",
          deletedAll: "All file lists were deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Help",
          companies: "Companies",
        },
        settings: {
          userCreation: {
            name: "User Creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabs: {
            options: "Options",
            schedules: "Schedules",
            plans: "Plans",
            help: "Help",
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            open: "Open",
            pending: "Pending",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send Greeting on Accepting Ticket",
            sendMsgTransfTicket:
              "Send Transfer Message between Departments/Agents",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            userRandom: "Random Agent Selection",
            buttons: "Buttons",
            acceptCallWhatsapp: "Notify that WhatsApp call is not accepted?",
            sendSignMessage: "Allow agent to choose to send Signature",
            sendGreetingMessageOneQueues:
              "Send Greeting when only one queue exists",
            sendQueuePosition: "Send Queue Position Message",
            sendFarewellWaitingTicket: "Send Farewell Message while Waiting",
            acceptAudioMessageContact:
              "Accept Audio Messages from All Contacts?",
            enableLGPD: "Enable LGPD Processing",
            requiredTag: "Required Tag to Close Ticket",
            closeTicketOnTransfer:
              "Close Ticket when Transferring to Another Queue",
            DirectTicketsToWallets: "Automatically Move Client to Wallet",
            showNotificationPending: "Show Notification for Pending Tickets",
            transferredTicketStatus:
              "Ticket status when transferring to an agent",
            copyContactPrefix: "Contact Copy Prefix",
            copyContactPrefixPlaceholder: "E.g.: COPY_",
          },
          customMessages: {
            sendQueuePositionMessage: "Queue Position Message",
            AcceptCallWhatsappMessage: "Message to Inform Call Not Accepted",
            greetingAcceptedMessage: "Greeting Message When Accepting Ticket",
            transferMessage:
              "Transfer Message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Welcome Message (LGPD)",
            linkLGPD: "Privacy Policy Link",
            obfuscateMessageDelete: "Obfuscate Deleted Message",
            alwaysConsent: "Always Request Consent",
            obfuscatePhoneUser: "Obfuscate User Phone Number",
            enabled: "Enabled",
            disabled: "Disabled",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          dialogRatingTitle:
            "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting Value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable Integration",
            disableIntegration: "Disable Integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
            greetingAcceptedMessage:
              "You must configure a greeting message when accepting the ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Type a message or press / for quick replies",
        placeholderOpen: "Type a message or press / for quick replies",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        privateMessage: "Private Message",
      },
      contactDrawer: {
        header: "Contact Details",
        buttons: {
          edit: "Edit Contact",
          block: "Block",
          unblock: "Unblock",
        },
        extraInfo: "Additional Information",
      },
      messageVariablesPicker: {
        label: "Available Variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol Number",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Sector",
          connection: "Connection",
          scheduledDate: "Scheduled Date",
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Resolve without Farewell",
        acceptAudioMessage: "Accept audio messages from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to register here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact",
          message:
            "Attention! All messages related to this ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send video conference link",
          triggerFlow: "Trigger Flow",
        },
        type: {
          imageVideo: "Photos and Videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video Call",
          template: "Meta Template",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        talkTo: "Talk To",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Expiration Date",
          action: "Action",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Method:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (registered token) and Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Message"',
        fieldUserId: '"userId": User ID or ""',
        fieldQueueId: '"queueId": Queue ID or ""',
        fieldSendSignature: '"sendSignature": Sign message - true/false',
        fieldCloseTicket: '"closeTicket": Close the ticket - true/false',
        singMessage: "Sign message - true/false",
        closeTicket: "Close the ticket - true/false",
        testSend: "The Test Send",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Interval filter value",
        sendAsManyTimes: " Send as many times",
        shipNormallyOnNonbusinessDays: "Ship normally on non-business days",
        sendOneBusinessDayBefore: "Send one business day before",
        sendOneBusinessDayLater: "Send one business day later",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
        servicePanel: {
          allowRealTime: "Service Panel",
        },
      },
      servicePanel: {
        allowRealTime: "Service Panel  ",
      },
      financial: {
        invoices: "Invoices",
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        value: "Value",
        expirationDate: "Due Date",
        status: "Status",
        action: "Action",
      },
      statusFilter: {
        statusFilter: "Filter by Status",
      },
      momentsUser: {
        services: "Services:",
        pending: "Pending",
        noqueue: "NO QUEUE",
      },
      campaignsPhrase: {
        campaignsFlow: "Campaigns Flow",
        campaigns: "Campaign",
        name: "Name",
        status: "Status",
        newCampaignWithFlowByPhrase: "New campaign with flow by phrase",
        editCampaignWithFlowByPhrase: "Edit campaign with flow by phrase",
        phraseTriggerName: "Phrase trigger name",
        chooseAStream: "Choose a stream",
        whichPhraseTriggersTheFlow: " Which phrase triggers the flow?",
        selectAConnection: " Select a Connection",
        chooseAStream: "Choose a stream",
        status: " Status",
        cancel: "CANCEL",
        createCampaign: "CREATE CAMPAIGN ",
        saveCampaign: "Sale Campaign",
      },
      chatList: {
        noMessages: "No messages",
        admin: "Admin",
        member: "Member",
        searchChat: "Search chat...",
        createNewChat: "Create new chat",
        searchUser: "Search user...",
        noUserFound: "No user found",
        noUserAvailable: "No user available",
        cancel: "Cancel",
        details: "Details",
        deleteChat: "Delete Chat",
        deleteChatConfirm: "This action cannot be undone, confirm?",
        detailsTitle: "Details",
        edit: "Edit",
        delete: "Delete",
        now: "now",
        minutesAgo: "{{count}}m ago",
        hoursAgo: "{{count}}h ago",
      },
      chatMessages: {
        deleted: "This message was deleted",
        deletedAdmin: "Deleted message - visible only to administrators",
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        editMessage: "Edit Message",
        save: "Save",
        cancel: "Cancel",
        deleteMessage: "Delete Message",
        deleteMessageConfirm: "Are you sure you want to delete this message?",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        doubleClickToReply: "Double click to reply",
        edited: "(edited)",
        forwarded: "(forwarded)",
        typeMessage: "Type a message...",
        send: "Send",
        noMessages: "No messages",
        loading: "Loading...",
        replyingTo: "Replying to",
        clickToGoToOriginal: "Click to go to original message",
      },
      chatPopover: {
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        cancel: "Cancel",
        confirmDelete: "Confirm Delete",
        confirm: "Confirm",
        deleteMessage: "Are you sure you want to delete this message?",
        editMessage: "Edit Message",
        save: "Save",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        forward: "Forward",
        noChats: "No chat available",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Groups",
        new: "New",
        messages: "Messages",
        search: "Search...",
        noChats: "No chat found",
        noGroups: "No group found",
        noMessages: "No messages",
        loading: "Loading...",
        error: "Error loading data",
        addGroupPhoto: "Add Group Photo",
        changeGroupPhoto: "Change Group Photo",
        groupName: "Group Name",
        groupDescription: "Group Description",
        save: "Save",
        cancel: "Cancel",
        createGroup: "Create Group",
        editGroup: "Edit Group",
        deleteGroup: "Delete Group",
        deleteGroupConfirm: "Are you sure you want to delete this group?",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        groupDetails: "Group Details",
        title: "Title",
        description: "Description",
        modal: {
          title: "Create Group",
          editTitle: "Edit Group",
          save: "Save",
          cancel: "Cancel",
          name: "Group Name",
          description: "Group Description",
          create: "Create",
          edit: "Edit",
        },
      },
      whatsappModalRel: {
        form: {
          isOficial: "Support Report",
          ticketId: "Ticket ID",
          client: "Customer",
          number: "Number",
          agent: "Agent",
          date: "Date",
          lastMessage: "Last Message",
          fullReport: "The full report is attached above",
          resolveAndTriggerIntegration: "Resolve and Trigger Integration",
          elementNotFoundForExport: "Element not found for export.",
          reportFilename: "support_report",
        },
      },
      whitelabel: {
        primaryColorLight: "Primary Color (Light Theme)",
        primaryColorDark: "Primary Color (Dark Theme)",
        appName: "Application Name",
        logoLight: "Logo (Light Theme)",
        logoDark: "Logo (Dark Theme)",
        favicon: "Favicon",
        backgroundLight: "Background Image (Light Theme)",
        backgroundDark: "Background Image (Dark Theme)",
        preview: "Preview",
        delete: "Delete",
        upload: "Upload",
        availableLanguages: "Available Languages",
        atLeastOneLanguage: "At least one language must be enabled",

        sections: {
          general: "General Settings",
          generalDescription: "Configure the application name and basic information",
          colors: "Colors and Themes",
          colorsDescription: "Customize primary colors for light and dark themes",
          logos: "Logos and Images",
          logosDescription: "Upload application logos and background images",
          languages: "Available Languages",
          languagesDescription: "Select which languages will be available in the system"
        }
      }
    },
  },
};

export { messages };
